import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { FormDto } from '../../../../models/form.dto';

@Component({
  selector: 'app-add-module',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './add-module.component.html',
  styleUrl: './add-module.component.scss',
})
export class AddModuleComponent {
  @Input() forms!: FormDto[];

  selectedFormCode?: string;

  @Output() newModule = new EventEmitter<Omit<FormDto, 'compositionId'>>();
  @Output() cancelled = new EventEmitter<void>();

  get uniqueForms(): FormDto[] {
    const seen = new Set<string>();
    return this.forms.filter((form) => {
      if (!seen.has(form.formType.code)) {
        seen.add(form.formType.code);
        return true;
      }
      return false;
    });
  }

  confirm(): void {
    const selectedForm = this.uniqueForms.find(
      (f) => f.formType.code === this.selectedFormCode
    );
    if (selectedForm) {
      const { compositionId, ...rest } = selectedForm;
      this.newModule.emit(rest);
    }
  }

  cancel(): void {
    this.cancelled.emit();
  }
}
